import produce from 'immer';
import {
  CLOSE_DEMO_BOOKING_SUMMARY_SCREEN, CONTINUE_DEMO_BOOKING_PRESSED,
  CREATE_DEMO_STUDIO_SCREEN_OPENED_FAILURE,
  CREATE_DEMO_STUDIO_SCREEN_OPENED_REQUEST,
  CREATE_DEMO_STUDIO_SCREEN_OPENED_SUCCESS, SETUP_APP_PRESSED, SETUP_APP_PRESSED_SUCCESS,
} from '../actionTypes';

export type CannotLaunchDemoBookingScreen = 'MAX_WORKOUTS_EXCEEDED' | 'LOGGED_IN_DIFFERENT_ACCOUNT' | null;

export interface IDemoBooking {
  loadingCreateDemoData: boolean;
  shouldOpenDemoBookingWizard: boolean;
  createDemoBookingScreenError: Error | null;
  loadingCloseDemoBookingSummary: boolean;
  cannotLaunchDemoBookingScreen: CannotLaunchDemoBookingScreen;
  userHasExceededMaxAllowedWorkouts: boolean;
  setupAppLoading: boolean;
  shouldNavigateToInstallAppScreen: boolean;
}

const initialState: IDemoBooking = {
  loadingCreateDemoData: false,
  shouldOpenDemoBookingWizard: false,
  createDemoBookingScreenError: null,
  loadingCloseDemoBookingSummary: false,
  cannotLaunchDemoBookingScreen: null,
  userHasExceededMaxAllowedWorkouts: false,
  setupAppLoading: false,
  shouldNavigateToInstallAppScreen: false,
};

export const demo = produce((
  draft: IDemoBooking = initialState,
  action: any): IDemoBooking => {
  switch (action.type) {
    case CREATE_DEMO_STUDIO_SCREEN_OPENED_REQUEST:
      draft.loadingCreateDemoData = true;
      break;
    case CREATE_DEMO_STUDIO_SCREEN_OPENED_SUCCESS:
      const calculateCannotLaunchDemoBookingScreen = (): CannotLaunchDemoBookingScreen => {
        if (!action.payload.allowDemoBookingsForGym) {
          return 'MAX_WORKOUTS_EXCEEDED';
        }
        if (action.payload.notLinkedToAppWithCurrentAuthedUser) {
          return 'LOGGED_IN_DIFFERENT_ACCOUNT';
        }
        return null;
      };
      draft.cannotLaunchDemoBookingScreen = calculateCannotLaunchDemoBookingScreen();
      draft.shouldOpenDemoBookingWizard = !draft.cannotLaunchDemoBookingScreen;
      draft.loadingCreateDemoData = false;
      draft.userHasExceededMaxAllowedWorkouts = !action.payload.allowDemoBookingsForGym;
      break;
    case CREATE_DEMO_STUDIO_SCREEN_OPENED_FAILURE:
      draft.createDemoBookingScreenError = action.payload.error;
      draft.loadingCreateDemoData = false;
      break;
    case CLOSE_DEMO_BOOKING_SUMMARY_SCREEN:
      draft.loadingCloseDemoBookingSummary = true;
      break;
    case CONTINUE_DEMO_BOOKING_PRESSED:
      draft.cannotLaunchDemoBookingScreen =  null;
      draft.shouldOpenDemoBookingWizard = true;
      break;
    case SETUP_APP_PRESSED:
      draft.setupAppLoading = true;
      draft.shouldNavigateToInstallAppScreen = action.payload.shouldNavigateToInstallAppScreen;
      break;
    case SETUP_APP_PRESSED_SUCCESS:
      draft.setupAppLoading = false;
      break;
  }
  return draft;
});
